import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  width: 100%;
  background: #10182e;
  color: #b6d0ff;
  text-align: center;
  padding: 2.5rem 1rem 1.5rem 1rem;
  font-size: 1.05rem;
  border-top: 2px solid #2d6cff33;
  margin-top: 4rem;
`;

const Footer = () => (
  <FooterWrapper>
    Need help? <a href="https://t.me/deserved0" style={{ color: '#2d6cff', textDecoration: 'none' }}>@deserved0</a> &bull; <a href="https://t.me/tomnookbank" style={{ color: '#2d6cff', textDecoration: 'none' }}>@tomnookbank</a><br />
    <span style={{ opacity: 0.7 }}>Deserved Warmer &copy; {new Date().getFullYear()}</span>
  </FooterWrapper>
);

export default Footer; 